import React from 'react';
import BookmarksList from '@/modules/articles/components/bookmarks/bookmark-list';
import { WidgetHost, DeepDiveWidget } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

export class BookmarksWidget implements DeepDiveWidget {
  defaultTitle = 'Bookmarks';

  readonly id = 'bookmarks';

  initialize(host: WidgetHost) {}

  get icon(): React.ReactNode {
    return <FontAwesomeIcon icon={faBookmark} />;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faBookmark} /> Bookmarks
      </>
    );
  }

  async hasPermission(permissions: string[]) {
    return true;
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <BookmarksList />,
      },
    ];
  }

  get defaultRoute(): string {
    return '';
  }
}

export const bookmarksWidget = new BookmarksWidget();
